import {CreationAttribute} from 'src/modules/event-create/typedefs';

export const setAttributesDeprecated = (attributes: CreationAttribute[], deprecated: boolean) =>
    attributes.map(attribute => ({...attribute, deprecated}));
